import { FC, HTMLAttributes } from 'react';

import cn from 'classnames';

import styles from './Page.module.scss';

interface IPageProps extends HTMLAttributes<HTMLDivElement> {}

export const Page: FC<IPageProps> = ({ className, children, ...props }) => {
	return (
		<div {...props} className={cn(className, styles.page)}>
			{children}
		</div>
	);
};
